import { render, staticRenderFns } from "./menuRelease.vue?vue&type=template&id=7d0f2318&scoped=true&"
import script from "./menuRelease.vue?vue&type=script&lang=js&"
export * from "./menuRelease.vue?vue&type=script&lang=js&"
import style0 from "./menuRelease.vue?vue&type=style&index=0&id=7d0f2318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0f2318",
  null
  
)

export default component.exports